// Older ambient actions stored ISO strings instead of Firestore timestamps.
export const actionDate = (value) => {
  if (value == null || value === "") return null;
  const date = typeof value.toDate === "function"
    ? value.toDate()
    : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};
